import { useEffect, useState } from 'react'

export const useOfflineMode = () => {
  const [isOffline, setIsOffline] = useState(false)

  const setOnline = () => setIsOffline(false)
  const setOffline = () => setIsOffline(true)

  useEffect(() => {
    window.addEventListener('online', setOnline)
    window.addEventListener('offline', setOffline)
    return () => {
      window.removeEventListener('online', setOnline)
      window.removeEventListener('offline', setOffline)
    }
  }, [])
  return { isOffline }
}
